import React, {useEffect} from "react";
import "./Catalog.scss";
import StoreOfUser from "./StoreOfUser/StoreOfUser";
import TrangThaiLoVTYT from "./TrangThaiLoVTYT";
import StoreVTYTList from "./StoreVTYTList";
import DanhMucPhieu from "./DanhMucPhieu";
import TrangThaiPhieu from "./TrangThaiPhieu";
import NguonVTYT from "./NguonVTYT";
import HangSanXuat from "./HangSanXuat";
import NhaCungCap from "./NhaCungCap";
import NhomVTYT from "./NhomVTYT";
import DanhMucVTYT from "./DanhMucVTYT";
import QuyCach from "./QuyCach";
import DonViTinh from "./DonViTinh";
import DonViApKQDT from "./DonViApKQDT";
import {useAppDispatch} from "redux/hooks";
import {getDonViTinhAPI} from "redux/reducer/medicalSupplies";
import BiddingDecision from "./BiddingDecision/BiddingDecision";

const Catalog = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(getDonViTinhAPI());
  }, []);
  return (
    <div className="catalog">
      <StoreOfUser></StoreOfUser>
      {/* <TrangThaiLoVTYT></TrangThaiLoVTYT> */}
      <StoreVTYTList></StoreVTYTList>
      {/* <DanhMucPhieu></DanhMucPhieu> */}
      {/* <TrangThaiPhieu></TrangThaiPhieu> */}
      {/* <NguonVTYT></NguonVTYT> */}
      <HangSanXuat></HangSanXuat>
      <NhaCungCap></NhaCungCap>
      <NhomVTYT></NhomVTYT>
      {/* <DonViTinh></DonViTinh> */}
      <QuyCach></QuyCach>
      {/* <DonViApKQDT></DonViApKQDT> */}
      <BiddingDecision></BiddingDecision>
      <DanhMucVTYT></DanhMucVTYT>
    </div>
  );
};
export default Catalog;
